export default {
  title: "Contacten"
}
